import { getDiagnosesBySignatureIdOptions, type PlanOfCareReviewViewModel } from '@generated';
import { Section } from '~/shared/section/Section';
import { SectionHeader } from '~/shared/section/SectionHeader';
import { getDiagnosesRoutePath } from '~/pages/charts/routes/PlanOfCareRoute';
import { DiagnosesTable } from '~/features/careplanning/diagnoses/DiagnosesTable';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

export function DiagnosesTab({ review }: { review: PlanOfCareReviewViewModel }) {
	const { data: diagnoses } = useSuspenseQuery(getDiagnosesBySignatureIdOptions(review.signatureId));
	const navigate = useNavigate();

	if (!diagnoses) return null;

	const handleNavigate = (url: string) => {
		navigate(url);
	};

	return (
		<Section>
			<SectionHeader
				title="Diagnoses"
				sectionButtonProps={{
					onClick: () =>
						handleNavigate(
							getDiagnosesRoutePath(
								review.data.patient.id,
								review.signature.certificationPeriod.stayId,
								review.signature.certificationPeriodId
							)
						)
				}}
			/>
			<DiagnosesTable rows={diagnoses.diagnoses} />
		</Section>
	);
}
